export default "__VITE_ASSET__9402bc0d__"